import ScribeImageElementModel from 'js/models/ScribeImageElementModel';

import { getBlendModeProperties } from './renderWithBlendMode';

export const getImageStyleProperties = (element: ScribeImageElementModel) => ({
  ...getBlendModeProperties(element.blendMode),
  opacity: element.opacity
});
